
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.449 14.901a.648.648 0 000 .91.633.633 0 00.901 0l7.284-7.356a.648.648 0 000-.91L1.35.189a.633.633 0 00-.901 0 .648.648 0 000 .91L7.092 8 .449 14.901z"}})])
          )
        }
      }
    